import { ErrorHandler, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { SnackbarService } from '@reenstudio/app/shared/services/snackbar/snackbar.service';
import { UiErrorMessage } from '@reenstudio/app/core/error/ui-error-message';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private logger: NGXLogger,
    private snackbarService: SnackbarService
  ) {}

  static throwError(msg: string) {
    throw new UiErrorMessage(msg);
  }

  handleError(error: any): void {
    this.logger.error(error);

    let msg = error.uiMessage ? error.uiMessage : 'Si è verificato un errore';

    this.snackbarService.error(msg);
  }
}
